// import dayjs from 'dayjs';

export const THERMOSPHERE = [
  {
    label: '--请选择--',
    value: undefined,
  },
  {
    label: '常温',
    value: '常温',
  },
  {
    label: '冷冻',
    value: '冷冻',
  },
  {
    label: '冷藏',
    value: '冷藏',
  },
  {
    label: '恒温',
    value: '恒温',
  },
];

export const SHIPPERSTATUS = [
  {
    label: '全部',
    value: undefined,
  },
  {
    label: '启用',
    value: '1',
  },
  {
    label: '禁用',
    value: '0',
  },
];

export const SHIPPERCARRIER = [
  {
    label: '全部',
    value: undefined,
  },
  {
    label: '已指定承运商',
    value: 'BIND',
  },
  {
    label: '未指定承运商',
    value: 'UNBIND',
  },
];
// 是否自营
export const ASCRIPTION_TYPE = [{
  value: 'SELF_EMPLOYED',
  label: '自营',
}, {
  value: 'JOIN',
  label: '加盟',
}];
// 仓库状态
export const WAREHOUSE_STATUS = {
  ENABLED: '启用',
  DISABLED: '禁用',
};
// 状态对应传值（英文）
export const WAREHOUSE_STATUS_VALUE = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
};
// 状态对应值（数字）1启用，0禁用
export const WAREHOUSE_STATUS_NUM = {
  ENABLED: '1',
  DISABLED: '0',
};
// 发布状态 PUBLISH(发布) REMOVE(移除)
export const PUBLISH_STATUS = {
  PUBLISH: '是',
  REMOVE: '否',
};
// 状态对应传值（英文）
export const PUBLISH_STATUS_VALUE = {
  PUBLISH: 'PUBLISH',
  REMOVE: 'REMOVE',
};
export const TABLECOLUMN = [
  {
    label: '仓库ID',
    prop: 'id',
    width: 180,
  }, {
    label: '仓库编码',
    prop: 'warehouseCode',
    width: 180,
  }, {
    label: '仓库名称',
    prop: 'warehouseName',
    width: 120,
  }, {
    label: '状态',
    prop: 'enabled',
    minWidth: 180,
    formatter: (row) => (row.enabled ? WAREHOUSE_STATUS.ENABLED : WAREHOUSE_STATUS.DISABLED),
  }, {
    label: '支持温层',
    prop: 'temperatureLayer',
    width: 180,
    formatter: (row) => row.temperatureLayer.map((item) => item.temperatureLayerName).join('、'),
  }, {
    label: '仓库面积',
    prop: 'area',
    width: 180,
  }, {
    label: '仓库地址',
    prop: 'address',
    width: 180,
    // formatter: (row) => `${row.provinceName || ''}${row.cityName || ''}${row.countyName || ''}${row.address || ''}`,
  }, {
    label: '是否发布到云仓',
    prop: 'published',
    minWidth: 180,
    formatter: (row) => (row.published ? PUBLISH_STATUS.PUBLISH : PUBLISH_STATUS.REMOVE),
  }, {
    label: '操作',
    prop: 'action',
    width: 250,
    fixed: 'right',
  },
];
